// app
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_FIRSTLOGIN = 'SET_FIRSTLOGIN'
export const SET_SLIDERSTATE = 'SET_SLIDERSTATE'
export const SET_LOCK_STATE = 'SET_LOCK_STATE'
export const SET_APPID = 'SET_APPID'
export const SET_DATA = 'SET_DATA'
export const SET_CUSTOMDISPLAYS = 'SET_CUSTOMDISPLAYS'

// user
export const SET_TOKEN = 'SET_TOKEN'
export const SET_NICKNAME = 'SET_NICKNAME'
export const SET_UID = 'SET_UID'
export const SET_NAME = 'SET_NAME'
export const SET_AVATAR = 'SET_AVATAR'
export const SET_MENUS = 'SET_MENUS'

// permission
export const SET_ROUTERS = 'SET_ROUTERS'
export const SET_MY_MENUS = 'SET_MY_MENUS'

// tagsview
export const ADD_VISITED_TAG = 'ADD_VISITED_TAG'
export const REMOVE_VISITED_TAG = 'REMOVE_VISITED_TAG'
export const CLOSE_OTHER_TAG = 'CLOSE_OTHER_TAG'
export const CLOSE_ALL_TAG = 'CLOSE_ALL_TAG'
export const SET_VIEWS = 'SET_VIEWS'
